<template>
  <!-- bg-full -->
  <bg-image :effect="{ type: 'zoom-in' }" :src="background" class="overlay-gradient bg-bottom bg-fixed" :class="{ 'activated': activeService }"></bg-image>

  <div class="container-fluid pt-xxl-vh-20 pt-xl-18 pt-lg-20 pt-md-16 pt-14 pb-sm-15 pb-15 z-1 min-vh-100">
    <div class="row justify-content-center">
      <div class="col-xxl-11 col-xl-14 col-lg-15 col-sm-14 col-15">
        <div class="row justify-content-between">
          <div class="col-lg-8">
            <h1 class="xxl-display-3 display-5"><span>Services</span></h1>

            <div class="mw-550 text-justify ps-1 mt-5 pe-xl-10 xxl-normal xsmall opacity-transition" :class="{ 'opacity-30': activeService }">
              <h2 class="xxl-normal xsmall ff-sans lh-base">Based in Athens, Greece, PRIME has established a reputation in the international shipping industry for operating and maintaining a fleet with high standards of safety performance and reliability.</h2>
              <p>It provides comprehensive management services for the vessels including technical supervision, such as repairs, maintenance and inspections, safety and quality, crewing and training, as well as supply provisioning. Commercial management services include operations, chartering, sale and purchase, post-fixture administration, accounting, freight invoicing and collection and insurance.</p>
              <p>We believe that ship management cannot be just another profit center within the Shipping Organization; passion, striving for improvement, a quest for excellence must be the key drivers rather than profit.</p>
            </div>
          </div>

          <div class="col-xl-8 col-lg-7 mt-lg-0 mt-10">
            <div class="services-wrapper">
              <button v-show="activeService" class="active-service" type="button" @click="deactivateService()">
                <p class="title"><span class="sep"></span> {{ activeService ? activeService.title : '' }} <i class="icon-arrow-right"></i></p>
                <div class="descr" v-html="activeService ? activeService.descr : ''"></div>
              </button>

              <div class="services activated">
                <button v-for="(service, index) in services" type="button" @click="activateService(service, $event)">
                  <p class="title"><span v-if="index + 1 < services.length" class="sep"></span> {{ service.title }} <i class="icon-arrow-right"></i></p>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>

const props = defineProps({
  background: {
    type: String,
    required: true,
    default: null,
  },
  services: {
    type: Array,
    required: true,
    default: null,
  },
});

import { ref, computed } from 'vue';
import { gsap } from 'gsap';

const activeService = ref(null);
let serviceTop = 0;
let duration = 1;
const activateTl = gsap.timeline();
const deactivateTl = gsap.timeline();

const activateService = (service, e) => {
  if (deactivateTl.isActive()) {
    return;
  }

  serviceTop = e.target.offsetParent.offsetTop;
  activeService.value = service;

  const serviceHeight = document.querySelector('.services button').offsetHeight;
  const servicesHeight = serviceHeight * (props.services.length - 1);
  duration = (serviceTop / servicesHeight);

  gsap.set(".active-service", { top: serviceTop, opacity: 1 });

  activateTl
    .to(".services button", {
      opacity: 0,
      stagger: 0.15,
      duration: 0.25
    })
    .to('.active-service', {
      top: 0,
      duration: duration,
      delay: -0.25
    })
    .to('.active-service .title .sep', {
      width: '100%',
      duration: 1,
      delay: -duration
    })
    .to('.active-service .title i', {
      rotate: '-90deg',
      duration: 0.25,
      delay: -duration,
    })
    .to('.active-service .descr', {
      opacity: 1,
      duration: 0.5,
      delay: -0.5,
      onComplete: () => {
        document.querySelector('.active-service').classList.add('activated');
        document.querySelector('.services').classList.remove('activated');
      }
    });
};

const deactivateService = () => {
  if (activateTl.isActive()) {
    return;
  }

  document.querySelector('.services').classList.add('activated');
  document.querySelector('.active-service').classList.remove('activated');

  deactivateTl
    .to('.active-service .descr', {
      opacity: 0,
      duration: 0.5
    })
    .to('.active-service .title i', {
      rotate: '0deg',
      duration: 0.5,
      delay: -0.5
    })
    .to('.active-service .title .sep', {
      width: 0,
      duration: 0.5
    })
    .to('.active-service', {
      top: serviceTop,
      duration: duration,
      delay: -1
    })
    .to(".services button", {
      opacity: 1,
      stagger: 0.15,
      duration: 0.25,
      onComplete: () => {
        activeService.value = null;
      }
    });
};

</script>

<style lang="scss"></style>